module.exports = __webpack_public_path__ + "img/titleIcon3.4086c399.png";